/**
 * Uzbek strings of the 09 redesign's inbox: `Murojaatlar` and the three-column `Suhbatlar`
 * (09 §6–§7, gap rows 4.1–4.13). Spread into `uz`, so a key here is a `TranslationKey` like any
 * other. Kept in its own file so the inbox work does not edit the shared dictionary line by line.
 */
export const uzInbox09 = {
  // ---------------------------------------------------------------- chips
  "inbox09.channel.label": "Kanal",
  "inbox09.liveRetrying": "Qayta ulanmoqda",
  "inbox09.search.label": "Suhbatlarni qidirish",
  "inbox09.section.inbox": "Suhbatlar",
  "inbox09.section.comments": "Instagram kommentlari",
  "inbox09.section.nav": "Suhbatlar va kommentlar",

  // ---------------------------------------------------------------- list rows
  "inbox09.list.label": "Suhbatlar ro'yxati",
  "inbox09.list.error": "Suhbatlar ro'yxatini yuklab bo'lmadi.",
  "inbox09.list.unknownClient": "Noma'lum mijoz",
  "inbox09.list.unread": "{count} ta o'qilmagan",
  "inbox09.list.pick": "{name} ni tanlash",
  "inbox09.retry": "Qayta urinish",
  "inbox09.time.now": "hozir",
  "inbox09.time.minutes": "{count} daq",
  "inbox09.time.yesterday": "kecha",
  "inbox09.claim.done": "Suhbat sizga o'tdi.",
  "inbox09.claim.taken": "Bu suhbatni {name} allaqachon oldi.",
  "inbox09.claim.failed": "Suhbatni olib bo'lmadi.",
  "inbox09.comment.kind": "Instagram izoh",
  "inbox09.comment.status": "Javob kutmoqda",

  // ---------------------------------------------------------------- murojaatlar
  "inbox09.need.adults": "{count} kattalar",
  "inbox09.need.children": "{count} bola",

  // ---------------------------------------------------------------- thread header
  "inbox09.header.dealCreated": "Bitim yaratildi.",
  "inbox09.header.dealExists": "Mijozning ochiq bitimi bor, suhbat unga bog'landi.",
  "inbox09.header.dealFailed": "Bitim yaratib bo'lmadi.",
  "inbox09.header.cancel": "Bekor qilish",

  // ---------------------------------------------------------------- the draft and the bubbles
  "inbox09.draft.label": "AI javobi tasdiqda",
  "inbox09.draft.source": "Manba: {sources}",
  "inbox09.draft.noSource": "Manba: bilim bazasidan iqtibos yo'q",
  "inbox09.draft.send": "Yuborish",
  "inbox09.draft.edit": "Tahrirlash",
  "inbox09.draft.reject": "Rad etish",
  "inbox09.draft.rejectReason": "Rad etish sababi",
  "inbox09.draft.rejectPlaceholder": "Nima noto'g'ri?",
  "inbox09.draft.sendFailed": "Qoralamani yuborib bo'lmadi.",
  "inbox09.draft.rejectFailed": "Qoralamani rad etib bo'lmadi.",
  "inbox09.draft.notYours": "Javobni suhbatni olgan xodim tasdiqlaydi.",
  "inbox09.bubble.aiSent": "AI yubordi · {time}",
  "inbox09.bubble.approvedBy": "{name} tasdiqladi",
  "inbox09.bubble.client": "Mijoz xabari",
  "inbox09.attachment.open": "Ochish: {kind}",
  "inbox09.attachment.pending": "Fayl Telegramdan olinmoqda",
  "inbox09.attachment.failed": "Faylni olib bo'lmadi",
  "inbox09.attachment.tooLarge": "Fayl juda katta, uni Telegramda oching",
  "inbox09.attachment.removed": "Saqlash muddati tugagani uchun fayl o'chirilgan",
  "inbox09.attachment.retry": "Qayta urinish",
  "inbox09.attachment.retryFailed": "Faylni qayta so'rab bo'lmadi.",

  // ---------------------------------------------------------------- composer
  "inbox09.composer.template": "Shablon",
  "inbox09.composer.tour": "Tur biriktirish",
  "inbox09.composer.checklist": "Hujjat ro'yxati",
  "inbox09.composer.note": "Ichki izoh",
  "inbox09.composer.file": "Fayl",
  "inbox09.composer.noteFailed": "Izohni saqlab bo'lmadi.",
  "inbox09.composer.checklistFailed": "Hujjatlar ro'yxatini olib bo'lmadi.",

  // ---------------------------------------------------------------- right panel
  "inbox09.panel.label": "Mijoz ma'lumoti",
  "inbox09.panel.error": "Ma'lumotni yuklab bo'lmadi.",
  "inbox09.panel.noClient": "Mijoz aniqlanmagan",
  "inbox09.panel.source": "Manba",
  "inbox09.panel.returning": "Qaytgan mijoz",
  "inbox09.panel.need": "AI aniqlagan ehtiyoj",
  "inbox09.panel.needEmpty": "Hali aniqlanmagan",
  "inbox09.panel.createDealWithNeed": "Shu ma'lumot bilan bitim yaratish",
  "inbox09.panel.visa": "Hujjatlar",
  "inbox09.panel.sendChecklist": "Hujjatlar ro'yxatini yuborish",
  "inbox09.panel.trips": "Oldingi sayohatlar",
  "inbox09.panel.tripsEmpty": "Avval sayohat qilmagan",
  "inbox09.panel.tasks": "Vazifalar",
  "inbox09.panel.call": "Qo'ng'iroq",
  "inbox09.panel.card": "Mijoz kartasi",

  // ---------------------------------------------------------------- a comment in the inbox
  "inbox09.commentView.label": "Instagram izoh",
  "inbox09.commentView.post": "Postni ochish",
  "inbox09.commentView.public": "Ochiq javob",
  "inbox09.commentView.direct": "Direktga o'tkazish",
  "inbox09.commentView.text": "Javob matni",
  "inbox09.commentView.publicSent": "Ochiq javob yuborildi.",
  "inbox09.commentView.directSent": "Direktga xabar yuborildi.",
  "inbox09.commentView.failed": "Javobni yuborib bo'lmadi.",
} as const;
